var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 control-section"},[_c('div',{staticClass:"tree-control-wrapper"},[_c('ejs-treeview',{ref:"RealtimeTaskTree",attrs:{"fields":_vm.fields,"nodeSelected":_vm.nodeSelectedOfMeasureTreeForTask}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }